import { Box, Card } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";
import { brainTokens } from "../design/brainTheme";
import { CardLabel } from "./KpiCard";

const c = brainTokens.color;

/**
 * The workhorse card: outlined 8px card with the design's padding and an
 * optional header row — an uppercase faint `label` OR a 15/600 `title`, plus an
 * `actions` slot on the right. Body = children.
 */
export function SectionCard({
  label,
  labelIcon,
  title,
  actions,
  children,
  padding = 22,
  headerMb = 18,
  sx,
}: {
  label?: ReactNode;
  labelIcon?: ReactNode;
  title?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  padding?: number | string;
  headerMb?: number | string;
  sx?: SxProps<Theme>;
}) {
  const hasHeader = label != null || title != null || actions != null;
  return (
    <Card sx={{ p: typeof padding === "number" ? `${padding}px` : padding, ...sx }}>
      {hasHeader && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            mb: typeof headerMb === "number" ? `${headerMb}px` : headerMb,
          }}
        >
          {title != null ? (
            <Box sx={{ fontSize: 15, fontWeight: 600, color: c.ink }}>{title}</Box>
          ) : label != null ? (
            <CardLabel icon={labelIcon}>{label}</CardLabel>
          ) : (
            <span />
          )}
          {actions != null && <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>{actions}</Box>}
        </Box>
      )}
      {children}
    </Card>
  );
}
